import React from 'react';

import Skeleton from 'react-loading-skeleton';

import useMediaQuery from 'hooks/use-media-query';

import {
  Heading,
  OfferContent,
  OfferContentWrap,
  OfferExpiration,
  OfferSkeletonButtonWrapper,
  OfferSkeletonDescription,
  OfferSkeletonImageWrapper,
  OfferSkeletonWrapper,
} from './styled';

export const OfferSkeleton = ({ isGridLayout }: { isGridLayout?: boolean }) => {
  const isDesktop = useMediaQuery('desktop');
  return (
    <OfferSkeletonWrapper $isGridLayout={isGridLayout} data-testid="th-offer-skeleton">
      <OfferSkeletonImageWrapper>
        <Skeleton />
      </OfferSkeletonImageWrapper>
      <OfferContent>
        <OfferContentWrap>
          <Heading>
            <Skeleton />
          </Heading>

          <OfferSkeletonDescription>
            <Skeleton width="90%" />
            <Skeleton width="70%" />
          </OfferSkeletonDescription>

          <OfferExpiration>
            <Skeleton width="56px" />
          </OfferExpiration>
        </OfferContentWrap>
        <OfferSkeletonButtonWrapper>
          <Skeleton height={isDesktop ? '55px' : '34px'} />
        </OfferSkeletonButtonWrapper>
      </OfferContent>
    </OfferSkeletonWrapper>
  );
};
